import ChartsService from './Base';

class SacStatus extends ChartsService {
  constructor() {
    super('sac-status');
  }
}

export default new SacStatus();
